/** @jsx jsx */

import { css, jsx } from '@emotion/core';
import EditableBtn from 'components/lib/EditableBtn';

const SubmitBtn = props => {
  const { enabled, onSubmit } = props;

  return (
    <div
      css={css`
        // // display: flex;
        // // justify-content: center;
        // width: 100%;
        ${!window.dev() &&
          `
            opacity: ${enabled ? 1 : 0.25};
            pointer-events: ${enabled ? 'auto' : 'none'};
            transition: opacity 0.5s;
        `}
      `}
    >
      <EditableBtn
        onClick={() => {
          onSubmit();
        }}
        enabled={enabled}
        {...props}
      />
    </div>
  );
};

export default SubmitBtn;
